import { HC_AGENCY_ID } from 'core/constants/environment'

function isHCAgent({ agency_id }) {
  return agency_id === HC_AGENCY_ID
}

export default isHCAgent
